import { CLIENT_PAGE_LOADED } from 'redux/modules/page/actions/types';

export const clientPageLoaded = () => ({
  type: CLIENT_PAGE_LOADED,
});
